import { Type } from '@angular/core';
import { ViewColumnComponent } from './view-column.component';

export class ViewColumn<T = any> {
  constructor(
    readonly index: number,
    public component: Type<ViewColumnComponent>,
    public compName: string,
    public localState: T
  ) {}
}
